import { StorageEnum } from "@/types/enum";

export type TimeZoneOption = {
  value: string;
  label: string;
};

export const DEFAULT_TIME_ZONE = "Asia/Shanghai";

export const COMMON_TIME_ZONE_OPTIONS: TimeZoneOption[] = [
  { value: "Asia/Shanghai", label: "Asia/Shanghai" },
  { value: "Africa/Lusaka", label: "	Africa/Lusaka" },
  { value: "UTC", label: "UTC" },
];

export function getLocalTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIME_ZONE;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

export function getCurrentTimeZone() {
  if (typeof window === "undefined") {
    return DEFAULT_TIME_ZONE;
  }

  try {
    const storedSettings = window.localStorage.getItem(StorageEnum.Settings);
    if (!storedSettings) {
      return DEFAULT_TIME_ZONE;
    }

    const parsedSettings = JSON.parse(storedSettings);
    const timeZone = parsedSettings?.state?.settings?.timeZone;
    return typeof timeZone === "string" && isValidTimeZone(timeZone) ? timeZone : DEFAULT_TIME_ZONE;
  } catch {
    return DEFAULT_TIME_ZONE;
  }
}

export function isValidTimeZone(timeZone: string) {
  try {
    Intl.DateTimeFormat("en-US", { timeZone }).format();
    return true;
  } catch {
    return false;
  }
}

export function getTimeZoneOffsetLabel(timeZone: string, date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "shortOffset",
    }).formatToParts(date);
    const offset = parts.find((part) => part.type === "timeZoneName")?.value ?? "GMT";

    if (offset === "GMT") {
      return "UTC + 0:00";
    }

    const match = offset.match(/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/);
    if (!match) {
      return offset.replace("GMT", "UTC");
    }

    return `UTC ${match[1]} ${Number(match[2])}:${match[3] ?? "00"}`;
  } catch {
    return "UTC + 0:00";
  }
}
